import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import "@fortawesome/fontawesome-free/css/all.min.css";
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import { LangProvider } from './contexts/LangContext';
import { CategoriesProvider } from './contexts/CategoriesContext';
import { installTokenRefresh } from './utils/tokenRefresh';

// Installé avant tout rendu : chaque réponse authentifiée peut porter un jeton
// renouvelé, y compris celles émises au tout premier chargement.
installTokenRefresh();

const RED = "#a21b1b";
const RED_DARK = "#881616";

const theme = extendTheme({
  styles: {
    global: {
      body: {
        bg: '#F5F5F5',
        color: 'gray.800',
      },
    },
  },
  colors: {
    brand: {
      50: '#fdf2f2',
      100: '#fde8e8',
      200: '#fbb5b5',
      300: '#f48282',
      400: '#e05252',
      500: RED,
      600: RED_DARK,
      700: '#7a1f14',
      800: '#611810',
      900: '#4a120c',
    },
  },
  fonts: {
    heading: `'Plus Jakarta Sans', 'Cairo', 'Inter', sans-serif`,
    body: `'Inter', 'Cairo', -apple-system, BlinkMacSystemFont, sans-serif`,
  },
  shadows: {
    soft: '0 4px 20px 0 rgba(0, 0, 0, 0.05)',
    medium: '0 8px 30px 0 rgba(0, 0, 0, 0.08)',
    card: '0 1px 3px rgba(0,0,0,0.05), 0 4px 12px rgba(0,0,0,0.06)',
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: '600',
        transition: 'all 0.2s',
      },
    },
    Input: {
      defaultProps: {
        variant: 'outline',
      },
    },
    Menu: {
      baseStyle: {
        list: {
          borderRadius: 'xl',
          boxShadow: 'xl',
          border: '1px solid',
          borderColor: 'gray.100',
          p: 2,
        },
        item: {
          borderRadius: 'md',
          _hover: { bg: 'gray.50' },
        },
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ChakraProvider theme={theme}>
    <LangProvider>
      <CategoriesProvider>
        <App />
      </CategoriesProvider>
    </LangProvider>
  </ChakraProvider>
);
